function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "5.7,39 3.8,39 3.8,39.8 5.6,39.8 5.6,40.5 3.8,40.5 3.8,41.4 5.8,41.4 5.8,42.1 3,42.1 3,38.4  5.7,38.4 5.7,39 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M8.2,41.1l0.4,0.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.4,0-1-0.3-1-1.3c0-1,0.6-1.3,1-1.3c0.4,0,1,0.3,1,1.3 c0,0.3-0.1,0.6-0.2,0.8l-0.4-0.4L8.2,41.1L8.2,41.1z M10,41.9l-0.4-0.4c0.2-0.3,0.4-0.7,0.4-1.3c0-1.7-1.3-1.9-1.8-1.9 c-0.5,0-1.8,0.2-1.8,1.9c0,1.7,1.3,1.9,1.8,1.9c0.2,0,0.6,0,0.9-0.2l0.4,0.4L10,41.9L10,41.9z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13.6,40.8c0,1-0.6,1.4-1.5,1.4c-0.3,0-0.8-0.1-1.2-0.4c-0.2-0.2-0.3-0.5-0.3-0.9v-2.4h0.8v2.4 c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.7-0.3,0.7-0.7v-2.4h0.8V40.8L13.6,40.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.6,39.2L15.6,39.2l0.5,1.5h-0.9L15.6,39.2L15.6,39.2z M14.9,41.3h1.4l0.2,0.8h0.8l-1.3-3.7h-0.9l-1.3,3.7 h0.8L14.9,41.3L14.9,41.3z"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "18.7,41.4 20.6,41.4 20.6,42.1 18,42.1 18,38.4 18.7,38.4 18.7,41.4 "
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "23.5,40.4 23.5,42.1 22.7,42.1 22.7,38.4 23.5,38.4 23.5,39.8 24.9,39.8 24.9,38.4 25.7,38.4  25.7,42.1 24.9,42.1 24.9,40.4 23.5,40.4 "
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M27.2,40.2c0-1,0.6-1.3,1-1.3c0.4,0,1,0.3,1,1.3c0,1-0.6,1.3-1,1.3C27.8,41.5,27.2,41.3,27.2,40.2L27.2,40.2z  M26.4,40.2c0,1.7,1.3,1.9,1.8,1.9c0.5,0,1.8-0.2,1.8-1.9c0-1.7-1.3-1.9-1.8-1.9C27.7,38.3,26.4,38.5,26.4,40.2L26.4,40.2z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M33.6,40.8c0,1-0.6,1.4-1.5,1.4c-0.3,0-0.8-0.1-1.2-0.4c-0.2-0.2-0.3-0.5-0.3-0.9v-2.4h0.8v2.4 c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.7-0.3,0.7-0.7v-2.4h0.8V40.8L33.6,40.8z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M35,40.9c0,0.2,0.1,0.6,0.8,0.6c0.4,0,0.8-0.1,0.8-0.5c0-0.3-0.3-0.4-0.7-0.5l-0.4-0.1 c-0.6-0.1-1.2-0.3-1.2-1.1c0-0.4,0.2-1.1,1.4-1.1c1.1,0,1.4,0.7,1.4,1.2h-0.7c0-0.2-0.1-0.6-0.8-0.6c-0.3,0-0.6,0.1-0.6,0.4 c0,0.3,0.2,0.3,0.4,0.4l0.9,0.2c0.5,0.1,1,0.3,1,1c0,1.1-1.1,1.2-1.5,1.2c-1.3,0-1.6-0.8-1.6-1.2H35L35,40.9z"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "38.7,42.1 38,42.1 38,38.4 38.7,38.4 38.7,42.1 "
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "41.8,38.4 42.5,38.4 42.5,42.1 41.7,42.1 40.2,39.5 40.2,39.5 40.2,42.1 39.5,42.1 39.5,38.4  40.3,38.4 41.8,41 41.8,41 41.8,38.4 "
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M45.1,40.1h1.5v2h-0.5L46,41.6c-0.2,0.2-0.5,0.6-1.1,0.6c-0.9,0-1.7-0.6-1.7-1.9c0-1,0.6-2,1.8-2 c1.1,0,1.6,0.7,1.6,1.2h-0.8c0-0.1-0.3-0.6-0.8-0.6c-0.6,0-1.1,0.4-1.1,1.3c0,1,0.5,1.3,1.1,1.3c0.2,0,0.7-0.1,0.9-0.8h-0.9V40.1 L45.1,40.1z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M3.6,45.8c0-1,0.6-1.3,1-1.3c0.4,0,1,0.3,1,1.3c0,1-0.6,1.3-1,1.3C4.2,47.1,3.6,46.9,3.6,45.8L3.6,45.8z  M2.9,45.8c0,1.7,1.3,1.9,1.8,1.9c0.5,0,1.8-0.2,1.8-1.9c0-1.7-1.3-1.9-1.8-1.9C4.1,43.9,2.9,44.1,2.9,45.8L2.9,45.8z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M8.5,45.7v-1.1h0.6c0.5,0,0.7,0.2,0.7,0.5c0,0.2,0,0.6-0.6,0.6H8.5L8.5,45.7z M8.5,46.4h0.9 c1,0,1.2-0.8,1.2-1.2c0-0.7-0.4-1.2-1.1-1.2H7.7v3.7h0.8V46.4L8.5,46.4z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M12.7,45.7v-1.1h0.6c0.5,0,0.7,0.2,0.7,0.5c0,0.2,0,0.6-0.6,0.6H12.7L12.7,45.7z M12.7,46.4h0.9 c1,0,1.2-0.8,1.2-1.2c0-0.7-0.4-1.2-1.1-1.2h-1.7v3.7h0.8V46.4L12.7,46.4z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.6,45.8c0-1,0.6-1.3,1-1.3c0.4,0,1,0.3,1,1.3c0,1-0.6,1.3-1,1.3C17.2,47.1,16.6,46.9,16.6,45.8L16.6,45.8z  M15.9,45.8c0,1.7,1.3,1.9,1.8,1.9c0.5,0,1.8-0.2,1.8-1.9c0-1.7-1.3-1.9-1.8-1.9C17.2,43.9,15.9,44.1,15.9,45.8L15.9,45.8z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M21.5,45.6v-1h1c0.5,0,0.5,0.3,0.5,0.5c0,0.4-0.2,0.5-0.6,0.5H21.5L21.5,45.6z M20.8,47.7h0.8v-1.4h0.8 c0.6,0,0.6,0.2,0.6,0.7c0,0.4,0,0.6,0.1,0.7h0.9v-0.1c-0.2-0.1-0.2-0.2-0.2-0.7c0-0.7-0.2-0.8-0.5-0.9c0.4-0.1,0.6-0.5,0.6-0.9 c0-0.3-0.2-1-1.2-1h-1.9V47.7L20.8,47.7z"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "26.6,47.7 25.9,47.7 25.9,44.6 24.8,44.6 24.8,44 27.8,44 27.8,44.6 26.6,44.6 26.6,47.7 "
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M31.9,46.4c0,1-0.6,1.4-1.5,1.4c-0.3,0-0.8-0.1-1.2-0.4c-0.2-0.2-0.3-0.5-0.3-0.9V44h0.8v2.4 c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.7-0.3,0.7-0.7V44h0.8V46.4L31.9,46.4z"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "35.6,44 36.3,44 36.3,47.7 35.6,47.7 34.1,45.1 34.1,45.1 34.1,47.7 33.3,47.7 33.3,44 34.1,44  35.6,46.6 35.6,46.6 35.6,44 "
});

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "38.5,47.7 37.7,47.7 37.7,44 38.5,44 38.5,47.7 "
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "41.5,47.7 40.7,47.7 40.7,44.6 39.6,44.6 39.6,44 42.6,44 42.6,44.6 41.5,44.6 41.5,47.7 "
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "45.5,47.7 44.8,47.7 44.8,46.3 43.5,44 44.4,44 45.2,45.6 45.9,44 46.8,44 45.5,46.3 45.5,47.7 "
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M24.8,0L0,12.2V18h2.8v17.2h43.9V18H50v-5.7L24.8,0L24.8,0z M41.3,30H8.1V14.3l16.7-8.5l16.5,8.5V30L41.3,30z"
});

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "32.4,19.8 17,19.8 17,14.3 32.4,14.3 32.4,19.8 "
});

var _ref28 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "32.4,27.8 17,27.8 17,22.2 32.4,22.2 32.4,27.8 "
});

var SvgEqualHousingOpportunityLogo = function SvgEqualHousingOpportunityLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 47.8",
    style: {
      enableBackground: "new 0 0 50 47.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEqualHousingOpportunityLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/equal-housing-opportunity-logo.1e9ff0de.svg";
export { ForwardRef as ReactComponent };